<!--<div class="page-sub-title">Events</div>-->

<div *ngIf="visibleComponent === 'LIST'">
    <!--<div class="card" *ngFor="let evt of eventList" (click)="navigateToEvent(evt)">
        {{evt.eventName}}
    </div>-->

    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>Events</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let evt of eventList" (click)="navigateToEvent(evt)">
            <td>
              {{ evt.eventName }}
            </td>
          </tr>
        </tbody>
        </table>
    </div>

    <div id="admin-controls" *ngIf="canAddEvent">
        <button (click)="switchVisibleComponent('CREATE')">Add Event</button>
    </div>
</div>



<div *ngIf="visibleComponent === 'CREATE'">
    <app-create-event (saved)="refreshEventList()"></app-create-event>
    <button (click)="switchVisibleComponent('LIST')">Cancel</button>
</div>